// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as Primitive_exceptions from "@rescript/runtime/lib/es6/Primitive_exceptions.js";

let UnknownStringValue = /* @__PURE__ */Primitive_exceptions.create("OrderStatus.UnknownStringValue");

function toString(status) {
  return status;
}

function toLabel(x) {
  if (x === "TO_PAY") {
    return I18n.t("Received - To pay");
  } else if (x === "DRAFT") {
    return I18n.t("Draft");
  } else if (x === "NOT_RECEIVED") {
    return I18n.t("");
  } else if (x === "REFUSED") {
    return I18n.t("Refused");
  } else if (x === "FINALIZED") {
    return I18n.t("Finalized");
  } else if (x === "ACCEPTED") {
    return I18n.t("Accepted - Not received");
  } else if (x === "PAID") {
    return I18n.t("Received - Paid");
  } else if (x === "RECEIVING") {
    return I18n.t("Receiving");
  } else if (x === "SENT") {
    return I18n.t("Sent");
  } else if (x === "RECEIVED") {
    return I18n.t("Received");
  } else {
    return I18n.t("Archived");
  }
}

function fromStringExn(value) {
  switch (value) {
    case "ACCEPTED" :
      return "ACCEPTED";
    case "ARCHIVED" :
      return "ARCHIVED";
    case "DRAFT" :
      return "DRAFT";
    case "FINALIZED" :
      return "FINALIZED";
    case "NOT_RECEIVED" :
      return "NOT_RECEIVED";
    case "PAID" :
      return "PAID";
    case "RECEIVED" :
      return "RECEIVED";
    case "RECEIVING" :
      return "RECEIVING";
    case "REFUSED" :
      return "REFUSED";
    case "SENT" :
      return "SENT";
    case "TO_PAY" :
      return "TO_PAY";
    default:
      throw {
        RE_EXN_ID: UnknownStringValue,
        Error: new Error()
      };
  }
}

function has(orderStatuses, predicate) {
  return orderStatuses.some(status => status === predicate);
}

function toAction(x) {
  if (has(x, "DRAFT")) {
    return "FINALIZE";
  } else if (has(x, "FINALIZED")) {
    return "ACCEPT";
  } else if (has(x, "ACCEPTED")) {
    return "START_RECEPTION";
  } else if (has(x, "RECEIVING")) {
    return "FINISH_RECEPTION";
  } else if (has(x, "RECEIVED")) {
    return "PAY";
  } else {
    return "CANCEL";
  }
}

export {
  UnknownStringValue,
  toString,
  toLabel,
  fromStringExn,
  has,
  toAction,
}
/* I18n Not a pure module */
